import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectProductAndResultType } from '../redux/selectors';
import ProductType from '../enums/productType';
import ResultType from '../enums/resultType';
import { searchParametersSlice } from '../redux/slices';

export default class ManufacturedHousingType {
  constructor() {
    this.selector = '[data-housing-type="manufactured"]';
    store$.pipe(map(selectProductAndResultType), distinctUntilChanged())
    .subscribe(this.onProductOrResultTypeChange.bind(this));
  }

  /**
   * The dispatchAction function dispatches a fetchManufactured action with the payload obtained from the
   * getSearchCommands function.
   */
  dispatchFetchResultAction() {
    const payload = this.getSearchCommands();
    store.dispatch(searchParametersSlice.actions.fetchManufactured(payload));
  }

  /**
   * Gets the node element of luxury box.
   * @returns {Node} element.
   */
  getNode() {
    return document.querySelector(this.selector);
  }

  /**
   * getSearchCommands: Gets the search command property of this Housing Box.
   * @returns The search command property string.
   */
  getSearchCommands() {
    const searchCommandPropertyStructure = {
      productType: this.productTypeToApply,
      resultType: this.resultTypeToApply,
    };

    return searchCommandPropertyStructure;
  }

   /**
   * Updates the value of productType and resultType based on the input
   * "typeParameters".
   * @param typeParameters - The productType and resultType parameters are a strings 
   * that represents the values of the type of product and/or result types.
   */
   onProductOrResultTypeChange(typeParameters) {
    const { productType, resultType } = typeParameters;
    switch (true) {
      case productType === ProductType.Manufactured.toString() && resultType === ResultType.Homes.toString():
        this.productTypeToApply = ProductType.Homes.toString();
        this.resultTypeToApply = ResultType.Homes.toString();
        break;

      case productType === ProductType.Manufactured.toString() && resultType === ResultType.Locations.toString():
        this.productTypeToApply = ProductType.Communities.toString();
        this.resultTypeToApply = ResultType.Communities.toString();
        break;

      default:
        this.productTypeToApply = ProductType.Manufactured.toString();
        this.resultTypeToApply = ResultType.Homes.toString();
    }
    this.toggleSelect(productType);
  }

  toggleSelect(productType) {
    const node = this.getNode();
    if (productType === ProductType.Manufactured.toString()) {
      node.selected = true;
    } else {
      node.selected = false;
    }
  }
}
